import { useState, useRef, useCallback } from 'react';

/**
 * Debounced search input shared by the warehouses list pages.
 * `searchInput` is the live text field value; `search` only updates `delay`ms
 * after typing stops (or immediately on submit) and is what should drive queries.
 */
export function useDebouncedSearch(delay = 400) {
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');
  const timerRef = useRef(null);

  const handleSearchInputChange = useCallback((event) => {
    const value = event.target.value;
    setSearchInput(value);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setSearch(value), delay);
  }, [delay]);

  const handleSearchSubmit = useCallback((event) => {
    event.preventDefault();
    if (timerRef.current) clearTimeout(timerRef.current);
    setSearch(searchInput);
  }, [searchInput]);

  return { searchInput, search, handleSearchInputChange, handleSearchSubmit };
}
